import { MainNavItem } from '../main-nav-item/main-nav-item.component';

export const buyerNavItems: MainNavItem[] = [
  {
    title: 'Home',
    url: ['home'],
    icon: 'ti ti-home'
  },
  {
    title: 'Sourcing',
    url: ['projects', 'sourcing'],
    icon: 'ti ti-list-search',
    subNavItems: [
      { title: 'In progress', url: ['in-progress'], icon: 'ti ti-clock' },
      { title: 'Draft', url: ['drafts'], icon: 'ti ti-files-off' },
      { title: 'Closed', url: ['closed'], icon: 'ti ti-archive' }
    ]
  },
  {
    title: 'Procurement',
    url: ['projects', 'procurement'],
    icon: 'ti ti-shopping-cart',
    subNavItems: [
      { title: 'In progress', url: ['in-progress'], icon: 'ti ti-clock' },
      { title: 'Draft', url: ['drafts'], icon: 'ti ti-files-off' },
      { title: 'Closed', url: ['closed'], icon: 'ti ti-archive' }
    ]
  },
  {
    title: 'Suppliers',
    url: ['suppliers'],
    icon: 'ti ti-building-warehouse',
    subNavItems: [
      { title: 'Supplier List', url: ['home'], icon: 'ti ti-list' },
      { title: 'Approved', url: ['approved'], icon: 'pi pi-check-circle' },
      { title: 'Onboarding', url: ['onboarding'], icon: 'ti ti-atom-2' },
      { title: 'Do not use', url: ['donotuse'], icon: 'ti ti-square-x' },
      { title: 'NDA on File', url: ['nda'], icon: 'ti ti-signature' },
      { title: 'Archive', url: ['archive'], icon: 'ti ti-archive' }
    ]
  },
  {
    title: 'Parts library',
    url: ['parts'],
    icon: 'ti ti-triangle-square-circle'
  },
  {
    title: 'Analytics',
    url: ['analytics'],
    icon: 'ti ti-chart-donut',
    subNavItems: [
      { title: 'Suppliers', url: ['suppliers'], icon: 'ti ti-chart-bubble' },
      {
        title: 'Procurement',
        url: ['procurement'],
        icon: 'ti ti-chart-dots'
      }
    ]
  }
];

export const supplierNavItems: MainNavItem[] = [
  {
    title: 'Home',
    url: ['home'],
    icon: 'ti ti-home'
  },
  {
    title: 'Opportunities',
    url: ['opportunities'],
    icon: 'ti ti-list-search',
    subNavItems: [
      { title: 'In progress', url: ['quoting'], icon: 'ti ti-clock' },
      { title: 'Quote History', url: ['quote-history'], icon: 'ti ti-history' },
      { title: 'Find opportunities', url: ['community'], icon: 'ti ti-social' }
    ]
  },
  {
    title: 'Orders',
    url: ['orders'],
    icon: 'ti ti-shopping-cart',
    subNavItems: [
      { title: 'In progress', url: ['in-progress'], icon: 'ti ti-clock' },
      { title: 'Closed', url: ['closed'], icon: 'ti ti-file-check' }
    ]
  },
  {
    title: 'Customers',
    url: ['customers'],
    icon: 'ti ti-building-warehouse',
    subNavItems: [
      { title: 'Customer list', url: ['home'], icon: 'ti ti-list' },
      { title: 'NDA on file', url: ['nda'], icon: 'ti ti-signature' },
      { title: 'Archive', url: ['archive'], icon: 'ti ti-archive' }
    ]
  }
];
